import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const SporTotoSocialCoupon = loadable(() => pMinDelay(import('./SporTotoSocialCoupon'), 300), {
  fallback: <Loading />
});

const AsyncSporTotoSocialCoupon = props => {
  const metaConfiguration = props.metaConfiguration['/iddaa/kupon'];
  const title = metaConfiguration?.title;
  const description = metaConfiguration.description;
  const meta = metaConfiguration.meta;

  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'mobile-none',
    loadGameListFull: true,
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } bg-green`
      },
      title,
      description,
      meta
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <SporTotoSocialCoupon { ...props }/>
    </ApplicationLayout>
  );
};

AsyncSporTotoSocialCoupon.propTypes = {
  userAgent: PropTypes.object,
  metaConfiguration: PropTypes.object
};

export default AsyncSporTotoSocialCoupon;
